$(() => {
  $tab = $('.section-professional-table__tab button')
  $content = $('.section-professional-table__content')

  $tab.on('click', function() {
    $this = $(this)
    $index = $tab.index($this)
    $tab.removeClass('active')
    $this.addClass('active')

    $content.removeClass('active')
    $content.eq($index).addClass('active')
  })
})

$(() => {
  if($('.section-contact').length) {
    const $radio_list = $('.section-contact input[name=user-type]')

    function change_url() {
      const $select_item = $radio_list.filter(':checked')

      $('#form-link').attr('href', $select_item.attr('value'))
    }

    $(window).on('load', change_url)
    $radio_list.on('change', change_url)
  }

  if($('.section-simulation').length) {
    const $radio_list = $('.section-simulation-container input[name=user-type]')

    $radio_list.on('change', function() {
      const $select_item = $radio_list.filter(':checked')

      $('.section-simulation').hide().filter('[data-id="'+ $select_item.attr('value') +'"]').show()
    })
  }

  (() => {
    const $radio_list = $('.modal-line input[name=user-line-type]')

    $radio_list.on('change', function() {
      const $select_item = $radio_list.filter(':checked')

      $('.modal-line__btn').attr('href', $select_item.attr('value'))
    })
  })()
})
